import { BaseEnum } from "services/enums/baseEnum";

const listsEnum: Array<FormSubmissionStatusType> = [];

export class FormSubmissionStatusType extends BaseEnum {
  static CREATED = new FormSubmissionStatusType(0, "CREATED", "CREATED");
  static PENDING = new FormSubmissionStatusType(1, "PENDING", "PENDING");
  static LATE = new FormSubmissionStatusType(2, "LATE", "LATE");
  static REALIZED = new FormSubmissionStatusType(3, "REALIZED", "REALIZED");
  static FINISHED = new FormSubmissionStatusType(4, "FINISHED", "FINISHED");

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);
    listsEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listsEnum;
  }
}
